import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import { Tag } from '@/components/tag';
import { useClassificationCategories } from '@/data/inventory/useClassificationCategories';
export function DataClassTag(t0) {
  const $ = _c(5);
  const {
    name
  } = t0;
  const {
    lookup
  } = useClassificationCategories();
  const t1 = lookup[name]?.title ?? name;
  let t2;
  if ($[0] !== name) {
    t2 = <Tag content={name} />;
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Tooltip title={t1}>{t2}</Tooltip>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}